export const storeCredentials = {
    storeDomain: 'blendworth-interiors.myshopify.com',
    storefrontToken: '24c154ec51d43c4199f1a450b5be0158',
    // apiAccessToken: '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',
    storeId: 205
}

export const storeLanguages = {
    defaultCountryCode: 'US',
    defaultLanguageCode: 'EN',
}

export const retailSystem = {
    filterUrl: 'https://nazzq9i1k7.execute-api.us-east-1.amazonaws.com/rs-filter-api',
    apiRS: 'https://api.retailsystem.io/variant/GetProductVarintId',
    sendFormEmail: "https://api.retailsystem.io/Communication/SendFormEmail",
    sendContactFormEmail: "https://api.retailsystem.io/Communication/ContactForm",
    sendGenericEmail: "https://api.retailsystem.io/Communication/SendGenericEmail",
    //string empty is Relevance
    defaulSort: "",
    bookingEndpoint: "https://api.retailsystem.io/Booking/",
    saveCartInfo: "https://api.retailsystem.io/Cart/SaveCartInfo",
    cartCache: 'https://api.retailsystem.io/Cart',
    apiBaseUrl: 'https://api.retailsystem.io/',
}